import React, { useRef } from "react";
import { element, string } from "prop-types";

import SearchIcon from "../../atoms/icons/search-icon";
import { SearchBox } from "../SearchBoxBase";

import { staticTexts } from "../../utils/Translate";

import "./search-input.m.css";

const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1">
    {children}
  </label>,
  <button type="submit" className="search-button" styleName="search" key="2">
    <SearchIcon width={28} height={28} />
  </button>,
];

const SearchInput = ({ className, defaultValue = "", lang, ...ops }) => {
  const searchForm = useRef();

  return (
    <div styleName="container" className={className}>
      <SearchBox
        inputId="searchForm"
        inputClassName="search__form-input"
        template={DrawForm}
        formRef={searchForm}
        placeholder={staticTexts(lang).searchBoxText}
        initValue={defaultValue}
        {...ops}
      />
    </div>
  );
};

SearchInput.defaultProps = {
  className: "",
};

SearchInput.propTypes = {
  defaultValue: string,
  className: string,
  lang: string,
};

DrawForm.propTypes = {
  children: element.isRequired,
};

export default SearchInput;
